"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionaryListObj = void 0;
exports.dictionaryListObj = {
    test: [
        { label: '测试1', value: 1 },
        { label: '测试2', value: 2 },
    ],
    test2: [
        { label: 'test2', value: 1 }
    ]
};
